/**
 * 登录部分的api请求
 */
import fetch from "../fetch"

export default {
//获取 Python接口Token
    GetPythonToken(data) {
      return fetch({
        url: `yssxs/ResourceSetting/GetPythonToken`,
        method: "get",
        data
      });
    },
}


// WEBPACK FOOTER //
// ./src/api/apis/python.js